export default function hamburger() {
  const BURGER_BTN = document.querySelector('.cm4all-theme-js-hamburger');
  BURGER_BTN?.addEventListener('click', () => {
    document.body.classList.toggle(
      'cm4all-theme-navigation-mobile-drawer-fixed-body'
    );
    BURGER_BTN.classList.toggle('cm4all-theme-hamburger--active');
    document
      .querySelector('.cm4all-theme-navigation-mobile-drawer')
      ?.classList.toggle('cm4all-theme-navigation-mobile-drawer--open');
  });
}

/**
 * creates an icon in the place where you want it to be.
 *
 * @param {Element} menuSelector - selector of all items where you want to apply your icon / element
 * @param {boolean} openOnClick - defines if the icon should toggle an class on click
 * @param {Element} icon - the icon / element you want to apply to the menuSelector. A fallback icon is defined.
 * @param {string} iconPosition - sets the position of the icon in the dom. For options @see https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
 *
 * @return {undefined}
 *
 */
export const createCaretIcon = (
  menuSelector,
  openOnClick = true,
  icon = null,
  iconPosition = 'afterbegin'
) => {
  const NAV_ICON =
    icon ||
    '<svg class="menu-item-has-children__subnav-arrow" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/></svg>';
  const HAS_SUB_MENUS = document.querySelectorAll(menuSelector);
  for (const HAS_SUB_MENU of HAS_SUB_MENUS) {
    HAS_SUB_MENU.insertAdjacentHTML(iconPosition, NAV_ICON);
    if (openOnClick) {
      HAS_SUB_MENU.firstElementChild.addEventListener('click', function () {
        this.parentElement.classList.toggle('sub-nav--open');
      });
    }
  }
};
